import React, { useState } from 'react';
import { TopBar } from './components/TopBar';
import { LeftSidebar } from './components/LeftSidebar';
import { RightSidebar } from './components/RightSidebar';
import { BottomPanel } from './components/BottomPanel';
import { WorkflowCanvas } from './components/WorkflowCanvas';
export function App() {
  // State to track which node is selected in the canvas,
  // defaulting to 'n2' (Claude AI Summarise) to match the prompt's requested state.
  const [selectedNodeId, setSelectedNodeId] = useState<string | null>('n2');
  return <div className="h-screen w-screen bg-[#070b14] text-slate-300 flex flex-col overflow-hidden font-sans selection:bg-sky-500/30" data-id="element-0">
      <TopBar data-id="element-1" />

      <div className="flex-1 flex overflow-hidden relative" data-id="element-2">
        <LeftSidebar data-id="element-3" />

        <WorkflowCanvas selectedNodeId={selectedNodeId} onSelectNode={setSelectedNodeId} data-id="element-4" />

        <RightSidebar selectedNodeId={selectedNodeId} data-id="element-5" />
      </div>

      <BottomPanel data-id="element-6" />
    </div>;
}